<div class="background-totem-footer footer-totem">
    <div class="footer-component">
        <div class="background-footer">            
            <div class="footer-copyright d-flex justify-content-center align-items-center">
                <p class="m-0">&#169; Kreare Mobile {{ now | date:'yyyy'}} - <span class="tel-link"> 680380132</span></p>
            </div>
        </div>
    </div>
</div>